import axios from "@/libs/api.request";


const uploadProgress=0;
export function upLoadFile(params) {
    return axios.request({
        url: "UploadFile/UploadBatch",
        method: "POST",
        headers: {
            'Content-Type': 'multipart/form-data',
          },
        data:params,
    })
}
export default uploadProgress
// 删除信息
export function delPicInfo(id) {
    return axios.request({
        url: "WebFileInfo/Delete",
        method: "post",
        params:{id:id}
    })
}